import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Icon, OverlayTrigger, Tooltip } from '@openedx/paragon';
import { InfoOutline } from '@openedx/paragon/icons';

import LockedLanguages from './LockedLanguages';
import UpgradeBenefits from './UpgradeBenefits';
import messages from './messages';

const UpgradeModalBody = ({
  courseEnabledLanguages,
  isFBE,
  originalCourseLanguage,
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <span className="lead text-primary mb-2" style={{ display: 'inline-block', position: 'relative' }}>
        {formatMessage(messages.upgradeLanguageSectionTitle, {
          tooltip: (
            <OverlayTrigger
              placement="right"
              overlay={(
                <Tooltip id="langauge-translations-selection-tooltip">
                  {formatMessage(messages.upgradeLanguageSectionTooltip)}
                </Tooltip>
              )}
            >
              <Icon
                style={{
                  float: 'right',
                  display: 'inline',
                  position: 'absolute',
                  bottom: 8,
                }}
                src={InfoOutline}
                size="xs"
                className="ml-1"
                aria-label="info"
              />
            </OverlayTrigger>
          ),
        })}
      </span>
      <LockedLanguages {...{ courseEnabledLanguages, originalCourseLanguage }} />
      <UpgradeBenefits {...{ isFBE }} />
    </>
  );
};

UpgradeModalBody.propTypes = {
  courseEnabledLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isFBE: PropTypes.bool.isRequired,
  originalCourseLanguage: PropTypes.string.isRequired,
};

export default UpgradeModalBody;
